import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authExchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Rendered whenever the URL fragment carries a session_id from Emergent Auth. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname === "/" ? "/account" : location.pathname;
    (async () => {
      try {
        const user = await authExchangeSession(sessionId || "");
        setUser(user);
        navigate(target, { replace: true, state: { user } });
      } catch {
        setError("We couldn't complete your Google sign-in. Please try again.");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-sm text-red-300" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate("/", { replace: true })} className="btn-ghost mt-6" data-testid="auth-callback-home">
            Back to home
          </button>
        </div>
      ) : (
        <p className="font-mono text-sm text-zinc-500">Signing you in…</p>
      )}
    </main>
  );
}
